import React, { Component } from 'react';
import API from '../../api';

import logoWhite from '../common/app2soft/images/logo_white_140X40.png';
import logoFb from '../common/facebook.png';
import logoTw from '../common/twitter.png';
import logoGg from '../common/google.png';
import logoIn from '../common/in.png';

import './style.scss';

export default class Footer extends Component {

  constructor(props){
    super(props);
    this.trackingSocial = this.trackingSocial.bind();
  }

  trackingSocial = () => {
    API.trackingEvent("User","Click on LinkedIn link");
  }

  render() {
    return (
      <footer>
        <div className="site-footer">
          <section>
            <div className="wrapper">
              <div className="sitemap">
                <img className="logo" src={logoWhite} width="105"/>
              </div>
              <ul className="social-media">
                <li>Follow us</li>
                <li>
                  <a onClick={this.trackingSocial} href="https://www.linkedin.com/company/25042027/" target="_blank"><img src={logoIn} alt=""/></a>
                </li>
              </ul>
            </div>
          </section>
        </div>
      </footer>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/footer/index.js